import { useCallback, useEffect, useState } from "react";
import { useLiveQuery } from "dexie-react-hooks";
import { isLoggingEnabled, loggerState, setLoggingEnabled, subscribeLogger } from "@/lib/interactionLog/logger";
import { daysOnDevice, getMeta, refusedCount, waitingCount } from "@/lib/interactionLog/store";
import { isSyncing, subscribeSync, syncLogs } from "@/lib/interactionLog/sync";

/** This device's logging switch, upload status and per-day holdings, kept live. */
export function useInteractionLog() {
  const [enabled, setEnabledState] = useState(isLoggingEnabled);
  const [syncing, setSyncing] = useState(isSyncing);
  const [storeError, setStoreError] = useState(loggerState.storeError);

  useEffect(
    () =>
      subscribeLogger(() => {
        setEnabledState(isLoggingEnabled());
        setStoreError(loggerState.storeError);
      }),
    []
  );
  useEffect(() => subscribeSync(() => setSyncing(isSyncing())), []);

  const waiting = useLiveQuery(() => waitingCount(), [], 0);
  const refused = useLiveQuery(() => refusedCount(), [], 0);
  const days = useLiveQuery(() => daysOnDevice(), [], []);
  const lastSyncAt = useLiveQuery(() => getMeta("last_sync_at"), [], null);
  const lastSyncError = useLiveQuery(() => getMeta("last_sync_error"), [], null);

  const setEnabled = useCallback(next => {
    setLoggingEnabled(next);
    setEnabledState(next);
  }, []);

  const syncNow = useCallback(async () => {
    setSyncing(true);
    try {
      return await syncLogs("manual");
    } finally {
      setSyncing(isSyncing());
    }
  }, []);

  return { enabled, setEnabled, syncing, syncNow, waiting, refused, days, lastSyncAt, lastSyncError, storeError };
}
